import { erpAxios } from '..';

const getUserLoans = async (id, client) => {
  const { data } = await erpAxios.get(`/loan/getAllUserLoans/${id}`);
  return data;
};

export default getUserLoans;
